import { render, staticRenderFns } from "./SparePartKind.vue?vue&type=template&id=b98c2eca"
import script from "./SparePartKind.vue?vue&type=script&lang=ts"
export * from "./SparePartKind.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports